export default __webpack_public_path__ + "static/media/get_schwifty.c3d1dfc6.ttf";